import { useEffect, useState } from 'react';
import { PROJECT_VERSION } from '../utils/constants';

import gitInfo from '../../src/utils/gitInfo.json'

const StickyBuildInfo = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  const transitionDuration = 300; // ms
  const autoCloseDelay = 5000; // ms

  const buildTimestamp = new Date(gitInfo.timestamp);
  const pktTime = buildTimestamp.toLocaleDateString('en-GB', {
    timeZone: 'Asia/Karachi',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  // console.log(`[GIT] ${gitInfo.commitMessage} (${gitInfo.commitHash.substring(0, 7)} on ${gitInfo.commitDate})`);
  console.log(
  `%cLatest Commit: %c${gitInfo.commitMessage} (%c${gitInfo.commitHash.slice(0, 7)}%c on ${gitInfo.commitDate} by ${gitInfo.gitAuthor})`,
  'color: gray;',
  'color: cyan;',
  'color: orange;',
  'color: gray;',
  'color: purple;'
);

  const toggleTooltip = () => {
    if (!shouldRender) {
      setShouldRender(true);
      setTimeout(() => setIsVisible(true), 10);
    } else {
      setIsVisible(false);
    }
  };

  // ⏱ Auto-close timer
  useEffect(() => {
    let autoCloseTimeout;
    if (isVisible) {
      autoCloseTimeout = setTimeout(() => {
        setIsVisible(false);
      }, autoCloseDelay);
    }
    return () => clearTimeout(autoCloseTimeout);
  }, [isVisible]);

  // 🧹 Unmount after fade-out
  useEffect(() => {
    if (!isVisible && shouldRender) {
      const timeout = setTimeout(() => {
        setShouldRender(false);
      }, transitionDuration);
      return () => clearTimeout(timeout);
    }
  }, [isVisible, shouldRender]);

  return (
    // <>{process.env.REACT_APP_ENV ==='dev' &&
      <div
        className="position-fixed bottom-0 end-0 m-4 z-3"
        style={{ cursor: 'pointer', width: isVisible ? 'auto' : '40px' }}
        onClick={toggleTooltip}
      >
        <div
          className={`p-2 border-2 rounded-full bg-dark text-white rounded-circle d-flex align-items-center justify-content-center shadow ${process.env.REACT_APP_ENV !== 'dev' ? 'border-purple drop-shadow-3xl' : 'border-orange drop-shadow-3xl'}`}
          style={{ width: '40px', height: '40px' }}
          title="Build Info"
        >
          <i className="bi bi-shield-lock" style={{ fontSize: '1.25rem' }}></i>
        </div>

        {shouldRender && (
          <div className={`build-tooltip ${isVisible ? 'transition-in' : 'transition-out'}`}>
            <div><strong>Version:</strong> {PROJECT_VERSION}</div>
            <div><strong>Build:</strong> {pktTime}</div>
          </div>
        )}
      </div>
      // }</>
  );
};

export default StickyBuildInfo;